@if(paywallService.selectedCurrency()) {
<div class="paywall-cards">
  <div class="paywall-cards__top">
    <div>
      <span class="paywall-cards__small_info">Currency</span>
      <yon-pw-button-select alignSelf="flex-start" [buttons]="currencies()"
        [selectedButton]="paywallService.selectedCurrency()" (selectedButtonChange)="selectCurrency($event)">
      </yon-pw-button-select>
    </div>
    <div>
    </div>
    <div class="text-right">
      @if((settings()?.discount ?? 0) > 0) {
        <span class="paywall-cards__small_info">Save {{settings()?.discount}}% with Annual subscription</span>
      }
      <yon-pw-button-select alignSelf="flex-end" [buttons]="billingPeriods()"
        [selectedButton]="paywallService.selectedBillingPeriod()" (selectedButtonChange)="selectBillingPeriod($event)">
      </yon-pw-button-select>
    </div>
  </div>

  <div class="paywall-cards__row">
    @if (overflowing()) {
      <button type="button" class="paywall-cards__arrow" aria-label="Previous plans" aria-controls="pw-cards-scroller"
        [disabled]="!canScrollBack()" (click)="scrollCards(-1)">&#8249;</button>
    }
    <div #scroller id="pw-cards-scroller" class="paywall-cards__body"
      [class.paywall-cards__body--fade-start]="canScrollBack()"
      [class.paywall-cards__body--fade-end]="canScrollForward()"
      (scroll)="updateScrollState()">
      <div class="paywall-cards__cards">
        @for (chargePlan of cards(); track chargePlan.id) {
          <yon-pw-paywall-card (cardSelect)="selectChargePlan(chargePlan)">
            <div header>{{ chargePlan.name }}</div>
            <div description>
              {{ chargePlan | chargePlanData:'subTitle' }}
            </div>
            <div price class="pw-plan-price">
              @if (isQuantityPlan(chargePlan)) {
                @for (charge of quantityChargesOf(chargePlan); track charge.id ?? $index) {
                  <p class="pw-unit-label">{{ unitLabel(charge) }}</p>
                }
                <yon-pw-quantity-selector
                  [quantity]="quantityFor(chargePlan)"
                  [min]="boundsFor(chargePlan).min"
                  [max]="boundsFor(chargePlan).max"
                  [step]="boundsFor(chargePlan).step"
                  [helper]="seatsHelper(chargePlan)"
                  [ariaLabel]="'Number of seats, ' + chargePlan.name"
                  (quantityChange)="setQuantity(chargePlan, $event)">
                </yon-pw-quantity-selector>
              }
              <ul class="pw-charge-lines">
                @for (charge of chargePlan.charges; track charge.id ?? $index) {
                  <li class="pw-charge-line">
                    <span class="pw-charge-line__name">{{ charge.name }}</span>
                    <span class="pw-charge-line__amount">{{ chargeLabel(charge, chargePlan) }}</span>
                  </li>
                }
              </ul>
              <span class="pw-plan-price__total">{{ chargePlan | price:quantityFor(chargePlan) }}</span>
              @if (hasOneTime(chargePlan)) {
                <span class="pw-plan-price__one-time">{{ oneTimeLabel(chargePlan) }}</span>
              }
            </div>
            @if (chargePlan | chargePlanData:'includesTitle') {
              <h3>{{ chargePlan | chargePlanData:'includesTitle' }}</h3>
            }
            @if (chargePlan | chargePlanData:'includesSubTitle') {
              <div [innerHTML]="chargePlan | chargePlanData:'includesSubTitle'"></div>
            }
          </yon-pw-paywall-card>
        }
        @if (contactSales(); as contact) {
          <yon-pw-paywall-card [hidePrice]="true" (cardSelect)="selectContactSales()">
            <div header>{{ contact.title }}</div>
            <div description>
              {{ contact.subTitle }}
            </div>
            <span button>Contact Sales</span>
            @if (contact.includesTitle) {
              <h3>{{ contact.includesTitle }}</h3>
            }
            @if (contact.includesHtml) {
              <div [innerHTML]="contact.includesHtml"></div>
            }
          </yon-pw-paywall-card>
        }
      </div>
    </div>
    @if (overflowing()) {
      <button type="button" class="paywall-cards__arrow" aria-label="Next plans" aria-controls="pw-cards-scroller"
        [disabled]="!canScrollForward()" (click)="scrollCards(1)">&#8250;</button>
    }
  </div>

  <div class="paywall-cards__footer">
    <p>Prices excluding potential VAT</p>
  </div>
</div>
}
